module.exports = __webpack_public_path__ + "static/media/school-profile-ad4.5fbecd6c.jpg";